import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import AiavatarLanding from "./AiavatarLanding";
import AiAvatar from "./aiAvatarCreation/AiAvatar";
import AiAvatarContainer from "./AiAvatarContainer";

function AiAvatarRouter() {
    return (
        <Routes>
            <Route path="/" element={<AiAvatarContainer />} />
            <Route path="create/*" element={<AiAvatar />} />
            <Route path="chat/:modelId" element={<AiAvatarContainer />} />
            <Route path="landing" element={<AiavatarLanding />} />

            {/* <Route path="chat" element={<VoiceCloningChat />} /> */}

            <Route path="*" element={<Navigate to="." replace />} />
        </Routes>
    );
}

export default AiAvatarRouter;
